import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { storage } from '../firebase';

const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
const MAX_IMAGE_SIZE = 5 * 1024 * 1024;

export const validateProfileImage = (file) => {
  if (!file) return 'Choose an image to upload.';
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    return 'Use a JPG, PNG, or WebP image.';
  }
  if (file.size > MAX_IMAGE_SIZE) {
    return 'The image must be smaller than 5 MB.';
  }
  return '';
};

export const uploadProfileImage = async ({ file, userId }) => {
  const validationError = validateProfileImage(file);
  if (validationError) throw new Error(validationError);
  if (!userId) throw new Error('Sign in before uploading a profile photo.');

  // A stable object path ensures every account has only one current profile image.
  const imageRef = ref(storage, `profileImages/${userId}/profile`);
  await uploadBytes(imageRef, file, {
    contentType: file.type,
    cacheControl: 'public,max-age=3600',
  });
  const downloadUrl = await getDownloadURL(imageRef);
  const separator = downloadUrl.includes('?') ? '&' : '?';
  return `${downloadUrl}${separator}updated=${Date.now()}`;
};
